<template>
  <v-container style="margin-top:80px;">
    <v-dialog v-model="show_bank_help" max-width="420">
      <v-card>
        <v-card-title class="text-h6">
          Hur hittar jag mitt bankkonto-nummer?
        </v-card-title>

        <v-card-text>
          Ett svenskt bankkontonummer består alltid av clearingnummer (fyra
          siffror) och ett kontonummer.<br /><br />
          Antalet siffror i kontonumret varierar från bank till bank.<br /><br />

          Du hittar enklast ditt bankkonto-nummer genom att logga in på din
          bank-app. <br /><br /><span
            ><b
              >Obs: Detta är inte detsamma som det kortnummer som står på ditt
              betalkort!</b
            ></span
          >
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card class="mx-auto" dark style="background:transparent;" flat>
      <div style="text-align: center;">Utbetalningar</div>
      <v-card-text style="text-align: center;">
        Ange uppgifter för utbetalningar och få en överblick över framtida och
        tidigare transaktioner.
      </v-card-text>
    </v-card>

    <v-card flat style="background:transparent;">
      <v-card-text>
        <v-row justify="center" style="min-height:100%;" align="center">
          <v-col class="col-12 col-lg-4 my-8">
            <v-card
              class="mx-auto my-8"
              max-width="400px"
              id="donation_card"
              dark
              style="position:relative;z-index: 1;"
              :loading="donation_loading"
            >
              <v-btn
                @click="help_dialog = true"
                style="position: absolute;right:4px;"
                icon
              >
                <v-icon>help</v-icon>
              </v-btn>
              <v-card-text>
                <div>Donationer</div>

                <v-row class="mt-10">
                  <v-col style="padding-top:0;padding-bottom:0;" class="col-12">
                    <v-radio-group v-model="$store.state.STREAMER.PAYMENT_TYPE">
                      <v-radio
                        value="SWISH"
                        @click.native="setPayment('SWISH')"
                      >
                        <template slot="label"> Hihat-<b>direkt</b> </template>
                      </v-radio>

                      <v-radio
                        v-if="bank_or_bank2 === 'Bank'"
                        value="BANK"
                        @click.native="setPayment('BANK')"
                      >
                        <template slot="label">
                          Hihat-<b>classic</b>
                          <v-chip small class="ml-2">Rekommenderas</v-chip>
                        </template>
                      </v-radio>
                      <v-radio
                        v-else-if="bank_or_bank2 === 'Swish'"
                        value="BANK2"
                        @click.native="setPayment('BANK2')"
                      >
                        <template slot="label">
                          Hihat-<b>classic</b>
                          <v-chip small class="ml-2">Rekommenderas</v-chip>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-row
                    class="px-4"
                    v-if="
                      $store.state.STREAMER.PAYMENT_TYPE === 'BANK' ||
                        $store.state.STREAMER.PAYMENT_TYPE === 'BANK2'
                    "
                  >
                    <v-col class="col-6">
                      <v-select
                        :items="['Swish', 'Bank']"
                        label="Genom"
                        v-model="bank_or_bank2"
                      ></v-select>
                    </v-col>
                    <v-col class="col-6">
                      <v-text-field
                        v-if="bank_or_bank2 === 'Bank'"
                        placeholder=""
                        v-model="$store.state.STREAMER.BANKACCOUNT"
                        :hint="bank_name"
                        persistent-hint
                        append-icon="mdi-help-circle"
                        @click:append="show_bank_help = true"
                      >
                        <template slot="label">
                          Bankkonto
                        </template>
                      </v-text-field>
                      <v-text-field
                        v-else
                        label="Telefonnummer"
                        placeholder=""
                        v-model="$store.state.STREAMER.PHONE_NUMBER"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-4">
                      <v-text-field
                        label="Personnummer"
                        placeholder="YYMMDD-XXXX"
                        :rules="[rules.isValidSSN]"
                        v-model="$store.state.STREAMER.PERSONAL_NUMBER"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-4">
                      <v-text-field
                        label="Förnamn"
                        placeholder=""
                        v-model="$store.state.STREAMER.FIRST_NAME"
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-4">
                      <v-text-field
                        label="Efternamn"
                        placeholder=""
                        v-model="$store.state.STREAMER.LAST_NAME"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="$store.state.STREAMER.PAYMENT_TYPE === 'SWISH'"
                    class="px-4"
                  >
                    <v-col class="col-7">
                      <v-text-field
                        label="Telefonnummer"
                        placeholder=""
                        v-model="$store.state.STREAMER.PHONE_NUMBER"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-row>
              </v-card-text>
              <v-card-subtitle
                v-if="$store.state.STREAMER.PAYMENT_TYPE === 'BANK'"
              >
                Donationer betalas anonymt ut till angivet bankkonto varje månad
                den 25:e. Dina personuppgifter hålls hemliga för de som donerar.
              </v-card-subtitle>
              <v-card-subtitle
                v-if="$store.state.STREAMER.PAYMENT_TYPE === 'BANK2'"
              >
                Donationer betalas anonymt ut till angivet telefonnummer varje
                månad den 25:e. Dina personuppgifter hålls hemliga för de som
                donerar.
              </v-card-subtitle>
              <v-card-subtitle
                v-if="$store.state.STREAMER.PAYMENT_TYPE === 'SWISH'"
              >
                Donationer levereras direkt till din Swish. De som donerar får
                genom Bank-ID tillgång till ditt telefonnummer och ditt namn.
              </v-card-subtitle>
            </v-card>
          </v-col>

          <v-col class="col-12 col-lg-4 my-8">
            <v-card
              class="mx-auto my-8"
              width="400px"
              height="400px"
              id="hicards_card"
              dark
              :loading="hicards_loading"
            >
              <v-card-text>
                <div>Hihat Shop</div>

                <v-row>
                  <v-col>
                    <v-text-field
                      label="Bankkonto"
                      placeholder=""
                      v-if="$store.state.STREAMER.PAYMENT_TYPE === 'BANK'"
                      v-model="$store.state.STREAMER.BANKACCOUNT"
                    >
                      <template slot="append">
                        {{ bank_name }}
                      </template>
                    </v-text-field>
                    <v-text-field
                      v-else
                      label="Telefonnummer"
                      placeholder=""
                      v-model="$store.state.STREAMER.PHONE_NUMBER"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Personnummer"
                      placeholder=""
                      v-model="$store.state.STREAMER.PERSONAL_NUMBER"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      label="Förnamn"
                      placeholder=""
                      v-model="$store.state.STREAMER.FIRST_NAME"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Efternamn"
                      placeholder=""
                      v-model="$store.state.STREAMER.LAST_NAME"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-subtitle
                v-if="$store.state.STREAMER.PAYMENT_TYPE === 'BANK'"
                style="position: absolute;bottom:0;"
              >
                Hihat Shop-försäljning betalas ut till angivet bankkonto den
                25:e varje månad.
              </v-card-subtitle>
              <v-card-subtitle v-else style="position: absolute;bottom:0;">
                Hihat Shop-försäljning betalas ut till angivet telefonnummer den
                25:e varje månad.
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat style="background:transparent;" height="500" dark>
      <v-tabs
        style="background:transparent !important;"
        centered
        dark
        v-model="tab"
      >
        <v-tab style="background:transparent !important;">
          Senaste veckan
        </v-tab>
        <v-tab style="background:transparent !important;">
          Senaste Månaden
        </v-tab>
        <v-tab style="background:transparent !important;">
          Sedan början
        </v-tab>
      </v-tabs>

      <v-card
        :loading="loading"
        class="mx-auto"
        dark
        flat
        style="background:transparent;margin-top:10px;"
      >
        <p style="font-size:1em;text-align: center;">
          <span
            >Total för period: <b>{{ Math.round(totals[tab]) }} kr</b></span
          >
        </p>
        <line-chart
          :key="tab"
          :height="450"
          :chartdata="chartdata"
          v-if="!loading"
          :options="options"
        />
        <v-card-text style="height: 350px;" v-else>
          <v-row style="width:100%;height:100%" align="center" justify="center">
            <v-col align="center">
              Ingen data
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card>
    <v-tabs
      style="background:transparent !important;margin-top:30px;"
      centered
      dark
    >
      <v-tab style="background:transparent !important;">
        Utbetalningar
      </v-tab>
    </v-tabs>
    <v-row
      v-if="future_deposit !== null"
      style="max-width: 800px;"
      class="mx-auto"
      justify="center"
      align="center"
    >
      <v-col cols="12">
        <v-card dark class="mx-auto" v-if="future_deposit !== null">
          <v-list-item style="display:flex;">
            <v-list-item-content>
              <div class="overline">id: Ej satt</div>
            </v-list-item-content>

            <v-spacer></v-spacer>
            <v-list-item-content
              style="text-align: center;white-space: nowrap; overflow: unset; }"
            >
              <div class="overline">
                <b v-if="future_deposit.START_DATE">{{
                  future_deposit.START_DATE.substring(0, 10)
                }}</b>
                -
                <b v-if="future_deposit.END_DATE">{{
                  future_deposit.END_DATE.substring(0, 10)
                }}</b>
              </div>
            </v-list-item-content>

            <v-spacer></v-spacer>

            <v-list-item-content style="text-align: right;">
              <div class="overline" @click="show_future_calculations">
                <v-btn small icon><v-icon small>mdi-calculator</v-icon></v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>

          <v-card-text
            style="padding-top:0;padding-bottom: 0;margin-top:-10px;"
          >
            <v-row
              align="center"
              style="max-height: 100px;padding-bottom: 20px;"
            >
              <v-col cols="3" align="center" style="padding: 0;">
                <v-list-item two-line style="padding: 0;">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip small label>{{ pay_day }} </v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle>planerad </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="3" align="center" style="padding: 0;">
                <v-list-item two-line style="padding: 0;">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="red" small label
                        >{{ future_deposit.DONATION_PART }} kr</v-chip
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>donationer</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="3" align="center" style="padding: 0;">
                <v-list-item two-line style="padding: 0;">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="blue" small label
                        >{{ future_deposit.HICARDS_PART }} kr</v-chip
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>shop</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="3" align="center" style="padding: 0;">
                <v-list-item two-line style="padding: 0;">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="green" small label
                        >{{
                          future_deposit.SALARY_UNTAXED -
                            future_deposit.SALARY_TAXED
                        }}
                        kr</v-chip
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>lön</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      style="max-width: 800px;"
      class="mx-auto"
      justify="center"
      align="center"
    >
      <v-col cols="12" v-for="(deposit, index) in deposits" :key="index">
        <v-card dark class="mx-auto">
          <v-list-item style="display:flex;">
            <v-list-item-content>
              <div class="overline">id: {{ deposit.id }}</div>
            </v-list-item-content>

            <v-spacer></v-spacer>
            <v-list-item-content
              style="text-align: center;white-space: nowrap; overflow: unset; }"
            >
              <div class="overline">
                <b>{{ deposit.FROM_DATE }}</b> - <b>{{ deposit.TO_DATE }}</b>
              </div>
            </v-list-item-content>

            <v-spacer></v-spacer>

            <v-list-item-content style="text-align: right;">
              <div class="overline" @click="show_calculations(deposit)">
                <v-btn small icon><v-icon small>mdi-calculator</v-icon></v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>

          <v-card-text
            style="padding-top:0;padding-bottom: 0;margin-top:-10px;"
          >
            <v-row
              align="center"
              style="max-height: 100px;padding-bottom: 20px;"
            >
              <v-col cols="3" align="center" style="padding: 0;">
                <v-list-item two-line style="padding: 0;">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip small label>{{ deposit.DATE_REG }} </v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >utbetalad
                      <v-icon small
                        >mdi mdi-checkbox-marked-circle-outline</v-icon
                      ></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="3" align="center" style="padding: 0;">
                <v-list-item two-line style="padding: 0;">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="red" small label
                        >{{ deposit.DONATION_EARNED }} kr</v-chip
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>donationer</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="3" align="center" style="padding: 0;">
                <v-list-item two-line style="padding: 0;">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="blue" small label
                        >{{ deposit.HICARDS_EARNED }} kr</v-chip
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>shop</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="3" align="center" style="padding: 0;">
                <v-list-item two-line style="padding: 0;">
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-chip color="green" small label
                        >{{ deposit.AMOUNT }} kr</v-chip
                      ></v-list-item-title
                    >
                    <v-list-item-subtitle>lön</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="more_info_dialog" max-width="490">
      <v-card dark v-if="deposit_of_interest !== null" style="padding: 10px;">
        <v-card-text>
          <v-row>
            <v-col>
              Donationer*
            </v-col>
            <v-col>
              +
              {{
                deposit_of_interest.DONATION_EARNED -
                  deposit_of_interest.DONATION_FEE
              }}
              kr
            </v-col>
            <v-col>
              {{
                deposit_of_interest.DONATION_EARNED -
                  deposit_of_interest.DONATION_FEE
              }}
              kr
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Shop*
            </v-col>
            <v-col> + {{ deposit_of_interest.HICARDS_EARNED }} kr </v-col>
            <v-col>
              {{
                deposit_of_interest.DONATION_EARNED -
                  deposit_of_interest.DONATION_FEE +
                  deposit_of_interest.HICARDS_EARNED
              }}
              kr
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Moms
            </v-col>
            <v-col> - {{ deposit_of_interest.HICARDS_VAT }} kr </v-col>
            <v-col>
              {{
                deposit_of_interest.DONATION_EARNED -
                  deposit_of_interest.DONATION_FEE +
                  deposit_of_interest.HICARDS_EARNED -
                  deposit_of_interest.HICARDS_VAT
              }}
              kr
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Arbetsgivaravgift
            </v-col>
            <v-col>
              -
              {{
                deposit_of_interest.HICARDS_AGA +
                  deposit_of_interest.DONATIONS_AGA
              }}
              kr
            </v-col>
            <v-col>
              {{
                deposit_of_interest.DONATION_EARNED -
                  deposit_of_interest.DONATION_FEE +
                  deposit_of_interest.HICARDS_EARNED -
                  deposit_of_interest.HICARDS_VAT -
                  deposit_of_interest.HICARDS_AGA -
                  deposit_of_interest.DONATIONS_AGA
              }}
              kr
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Skatt
            </v-col>
            <v-col> - {{ deposit_of_interest.TAX }} kr </v-col>
            <v-col>
              {{
                deposit_of_interest.DONATION_EARNED -
                  deposit_of_interest.DONATION_FEE +
                  deposit_of_interest.HICARDS_EARNED -
                  deposit_of_interest.HICARDS_VAT -
                  deposit_of_interest.HICARDS_AGA -
                  deposit_of_interest.DONATIONS_AGA -
                  deposit_of_interest.TAX
              }}
              kr
            </v-col>
          </v-row>
          <v-divider dark></v-divider>
          <v-row>
            <v-col>
              Totalt
            </v-col>
            <v-col> </v-col>
            <v-col>
              {{
                deposit_of_interest.DONATION_EARNED -
                  deposit_of_interest.DONATION_FEE +
                  deposit_of_interest.HICARDS_EARNED -
                  deposit_of_interest.HICARDS_VAT -
                  deposit_of_interest.HICARDS_AGA -
                  deposit_of_interest.DONATIONS_AGA -
                  deposit_of_interest.TAX
              }}
              kr
            </v-col>
          </v-row>
          <small>* efter transaktionsavgift</small>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="future_more_info_dialog" max-width="490">
      <v-card dark v-if="future_deposit !== null" style="padding: 10px;">
        <v-card-text>
          <v-row>
            <v-col>
              Donationer*
            </v-col>
            <v-col> + {{ future_deposit.DONATION_PART }} kr </v-col>
            <v-col> {{ future_deposit.DONATION_PART }} kr </v-col>
          </v-row>
          <v-row>
            <v-col>
              Shop*
            </v-col>
            <v-col> + {{ future_deposit.HICARDS_PART }} kr </v-col>
            <v-col>
              {{ future_deposit.DONATION_PART + future_deposit.HICARDS_PART }}
              kr
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Moms
            </v-col>
            <v-col> - {{ future_deposit.HICARDS_VAT }} kr </v-col>
            <v-col>
              {{
                future_deposit.DONATION_PART +
                  future_deposit.HICARDS_PART -
                  future_deposit.HICARDS_VAT
              }}
              kr
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Arbetsgivaravgift
            </v-col>
            <v-col>
              -
              {{
                future_deposit.HICARDS_EMPLOYER_FEE +
                  future_deposit.DONATION_EMPLOYER_FEE
              }}
              kr
            </v-col>
            <v-col>
              {{
                future_deposit.DONATION_PART +
                  future_deposit.HICARDS_PART -
                  future_deposit.HICARDS_VAT -
                  future_deposit.HICARDS_EMPLOYER_FEE -
                  future_deposit.DONATION_EMPLOYER_FEE
              }}
              kr
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Skatt
            </v-col>
            <v-col> - {{ future_deposit.SALARY_TAXED }} kr </v-col>
            <v-col>
              {{
                future_deposit.DONATION_PART +
                  future_deposit.HICARDS_PART -
                  future_deposit.HICARDS_VAT -
                  future_deposit.HICARDS_EMPLOYER_FEE -
                  future_deposit.DONATION_EMPLOYER_FEE -
                  future_deposit.SALARY_TAXED
              }}
              kr
            </v-col>
          </v-row>
          <v-divider dark></v-divider>
          <v-row>
            <v-col>
              Totalt
            </v-col>
            <v-col> </v-col>
            <v-col>
              {{
                future_deposit.DONATION_PART +
                  future_deposit.HICARDS_PART -
                  future_deposit.HICARDS_VAT -
                  future_deposit.HICARDS_EMPLOYER_FEE -
                  future_deposit.DONATION_EMPLOYER_FEE -
                  future_deposit.SALARY_TAXED
              }}
              kr
            </v-col>
          </v-row>
          <small>* efter transaktionsavgift</small>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="help_dialog" width="800" dark :content-class="'fillme'">
      <v-simple-table
        dark
        style="max-width:800px;background: linear-gradient(40deg, rgba(96,55,170,0.72) 0%, rgb(41,160,118) 100%);"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th style="color:white !important;" class="text-left"></th>
              <th style="color:white !important;" class="text-left">Swish</th>
              <th style="color:white !important;" class="text-left">Skattat</th>
              <th style="color:white !important;" class="text-left">Anonymt</th>
              <th style="color:white !important;" class="text-left">
                Alert-garanti
              </th>
              <th style="color:white !important;" class="text-left">
                Utbetalningstyp
              </th>
              <th style="color:white !important;" class="text-left">
                Start-avgift
              </th>
              <th style="color:white !important;" class="text-left">
                Transaktions-avgift
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Hihat <b>classic</b></td>
              <td><v-icon>mdi-check</v-icon></td>
              <td><v-icon>mdi-check</v-icon></td>
              <td><v-icon>mdi-check</v-icon></td>
              <td><v-icon>mdi-check</v-icon></td>
              <td>Månadsvis</td>
              <td>0 kr</td>
              <td>3.25 SEK + 3.25 %</td>
            </tr>
            <tr>
              <td>Hihat <b>direkt</b></td>
              <td><v-icon>mdi-check</v-icon></td>
              <td><v-icon>mdi-close</v-icon></td>
              <td><v-icon>mdi-close</v-icon></td>
              <td><v-icon>mdi-close</v-icon></td>
              <td>Direkt</td>
              <td>0 kr</td>
              <td>3.25 SEK + 3.25 %</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-dialog>
  </v-container>
</template>

<script>
import * as k from "../helpers/kontonummer.js";
import LineChart from "../components/Chart.vue";

export default {
  name: "Payouts",
  components: { LineChart },
  data: function() {
    return {
      bank_or_bank2: "Swish",
      banks: [],
      show_bank_help: false,
      date: null,
      bank_name: "",
      save_streamer_timeout: null,
      donation_loading: false,
      hicards_loading: false,
      personal_loading: false,
      tab: 0,
      loading: "teal",
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              },
              id: "left-y-axis",
              type: "linear",
              position: "left",
              ticks: {
                min: 0,
              },
            },
            {
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              },
              id: "right-y-axis",
              type: "linear",
              position: "right",
              ticks: {
                min: 0,
              },
            },
          ],
        },
      },
      labels_week: [],
      num_week: [],
      earned_week: [],
      labels_month: [],
      num_month: [],
      earned_month: [],
      labels_all: [],
      num_all: [],
      earned_all: [],
      deposits: [],
      more_info_dialog: false,
      future_more_info_dialog: false,
      deposit_of_interest: null,
      future_deposit: null,
      pay_day: "",
      help_dialog: false,
      totals: [0, 0, 0],
      rules: {
        isValidSSN: (value) =>
          /^(19|20)?\d{2}(01|02|03|04|05|06|07|08|09|10|11|12)((0[1-9])|(1|2)[0-9]|(30|31))(-)?\d{4}$/.test(
            value
          ) || "Använd formatet: ÅÅMMDD-XXXX",
      },
    };
  },
  methods: {
    show_calculations: function(deposit) {
      this.deposit_of_interest = deposit;
      this.more_info_dialog = true;
    },
    show_future_calculations: function() {
      this.future_more_info_dialog = true;
    },
    getFutureDeposits: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = "/api/get_future_deposits";
      http.open("GET", url, true);
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      let self = this;
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status === 200) {
          let dd = "25";
          let mm = "";
          let yyyy = "";
          var today = new Date();

          if (today.getDate() > 25) {
            mm = String(today.getMonth() + 2).padStart(2, "0"); //January is 0!
            yyyy = today.getFullYear();
          } else {
            mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
            yyyy = today.getFullYear();
          }

          self.pay_day = yyyy + "-" + mm + "-" + dd;
          self.future_deposit = JSON.parse(http.response);
        }
      };
      http.send();
    },

    getDeposits: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = "/api/get_deposits";
      http.open("GET", url, true);

      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      let self = this;
      http.onreadystatechange = function() {
        //Call a function when the state changes.

        if (http.readyState === 4 && http.status === 200) {
          self.deposits = JSON.parse(http.response);
        }
      };
      http.send();
    },

    setPayment: function(paymentType) {
      this.$store.commit("update_payment_type", paymentType);
    },
    save_all_settings: function() {
      this.$store.commit("save_streamer");
    },

    get_payments_history: function() {
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = "/api/payments_history";

      http.open("GET", url, true);
      let self = this;
      http.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );

      http.onreadystatechange = function() {
        if (http.readyState === 4 && http.status === 200) {
          if (http.responseText !== "no data") {
            let data = JSON.parse(http.response);
            self.structure_data(data);
          }
        }
      };
      http.send();
    },
    structure_data: function(data) {
      for (let i = 0; i < data.week.length; i++) {
        let date = new Date(data.week[i]["date"]);
        this.labels_week[i] = `${date.getDate()}/${date.getMonth()}`;
        if (data.week[i]["COUNTED"] === null) {
          this.num_week[i] = 0;
          this.earned_week[i] = 0;
        } else {
          this.totals[0] += data.week[i]["SUMMED"];
          this.num_week[i] = data.week[i]["COUNTED"];
          this.earned_week[i] = data.week[i]["SUMMED"];
        }
      }

      for (let i = 0; i < data.month.length; i++) {
        let date = new Date(data.month[i]["date"]);
        this.labels_month[i] = `${date.getDate()}/${date.getMonth()}`;
        if (data.month[i]["COUNTED"] === null) {
          this.num_month[i] = 0;
          this.earned_month[i] = 0;
        } else {
          this.totals[1] += data.month[i]["SUMMED"];
          this.num_month[i] = data.month[i]["COUNTED"];
          this.earned_month[i] = data.month[i]["SUMMED"];
        }
      }
      for (let i = 0; i < data.all.length; i++) {
        this.labels_all[i] = data.all[i]["date"];
        if (data.all[i]["COUNTED"] === null) {
          this.num_all[i] = 0;
          this.earned_all[i] = 0;
        } else {
          this.totals[2] += data.all[i]["SUMMED"];
          this.num_all[i] = data.all[i]["COUNTED"];
          this.earned_all[i] = data.all[i]["SUMMED"];
        }
      }
      this.loading = false;
    },
  },
  computed: {
    chartdata: function() {
      return this.chartdatas[this.tab];
    },
    chartdatas() {
      return [
        {
          labels: this.labels_week,
          datasets: [
            {
              label: "Antal transaktioner",
              data: this.num_week,
              backgroundColor: ["rgba(255, 99, 132, 0.2)"],
              borderColor: ["rgba(255, 99, 132, 1)"],
              borderWidth: 1,
            },
            {
              label: "Summa transaktionsbelopp",
              data: this.earned_week,
              backgroundColor: ["rgba(56,36,255,0.4)"],
              borderColor: ["rgb(91,40,255)"],
              borderWidth: 1,
            },
          ],
        },
        {
          labels: this.labels_month,
          datasets: [
            {
              label: "Antal transaktioner",
              data: this.num_week,
              backgroundColor: ["rgba(255, 99, 132, 0.2)"],
              borderColor: ["rgba(255, 99, 132, 1)"],
              borderWidth: 1,
            },
            {
              label: "Summa transaktionsbelopp",
              data: this.earned_month,
              backgroundColor: ["rgba(56,36,255,0.4)"],
              borderColor: ["rgb(91,40,255)"],
              borderWidth: 1,
            },
          ],
        },
        {
          labels: this.labels_all,
          datasets: [
            {
              label: "Antal transaktioner",
              data: this.num_all,
              backgroundColor: ["rgba(255, 99, 132, 0.2)"],
              borderColor: ["rgba(255, 99, 132, 1)"],
              borderWidth: 1,
            },
            {
              label: "Summa transaktionsbelopp",
              data: this.earned_all,
              backgroundColor: ["rgba(56,36,255,0.4)"],
              borderColor: ["rgb(91,40,255)"],
              borderWidth: 1,
            },
          ],
        },
      ];
    },
    is_personal() {
      if (
        this.$store.state.STREAMER.PAYMENT_TYPE === "BANK" ||
        this.$store.state.STREAMER.PAYMENT_TYPE === "BANK2" ||
        this.$store.state.HICARDS.ACTIVE
      ) {
        return true;
      } else {
        return false;
      }
    },
    donation_setup() {
      if (
        this.$store.state.STREAMER.PAYMENT_TYPE === "SWISH" &&
        this.$store.state.STREAMER.PHONE_NUMBER.length > 7
      ) {
        return true;
      } else if (
        (this.$store.state.STREAMER.PAYMENT_TYPE === "BANK" ||
          this.$store.state.STREAMER.PAYMENT_TYPE === "BANK2") &&
        this.$store.state.STREAMER.BANKACCOUNT.toString().length > 7
      ) {
        return true;
      } else {
        return false;
      }
    },
    hicards_setup() {
      if (this.$store.state.HICARDS.ACTIVE) {
        if (this.$store.state.STREAMER.BANKACCOUNT.toString().length > 7) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    personal_setup() {
      if (this.is_personal) {
        if (
          this.$store.state.STREAMER.FIRST_NAME.length > 1 &&
          this.$store.state.STREAMER.LAST_NAME.length > 1 &&
          this.$store.state.STREAMER.PERSONAL_NUMBER.toString().length > 9
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
  },
  watch: {
    bank_or_bank2: function() {
      if (this.bank_or_bank2 === "Swish") {
        this.$store.state.STREAMER.PAYMENT_TYPE = "BANK2";
      } else {
        this.$store.state.STREAMER.PAYMENT_TYPE = "BANK";
      }
    },

    "$store.state.STREAMER.BANKACCOUNT": function() {
      let ba = this.$store.state.STREAMER.BANKACCOUNT;
      let result = k.kontonummer(ba.toString());
      this.bank_name = result["bank_name"];
    },
    "$store.state.STREAMER": {
      handler() {
        if (this.$store.state.APP.SETUP_LOADED) {
          clearTimeout(this.save_streamer_timeout);
          let self = this;
          this.save_streamer_timeout = setTimeout(function() {
            self.save_all_settings();
          }, 1500);
        }
      },
      deep: true,
    },
    "$store.state.HICARDS": {
      handler() {
        if (this.$store.state.APP.HICARDS_LOADED) {
          clearTimeout(this.save_streamer_timeout);
          let self = this;
          this.save_streamer_timeout = setTimeout(function() {
            self.save_all_settings();
          }, 1500);
        }
      },
      deep: true,
    },
  },
  mounted: function() {
    this.get_payments_history();
    this.getDeposits();
    this.getFutureDeposits();
  },
};
</script>

<style>
.v-tabs-bar {
  background: transparent !important;
}

.theme--dark.v-data-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.fillme {
  background: black;
}
</style>
